export default {
  label: 'Chat with our team',
  label_unread: 'Chat with our team, {{count}} new',
};
